import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import ModalHeader from './ModalHeader.js';
import Button from 'react-bootstrap/lib/Button';
import Icon from './Icon';
import i18n from '../../src/i18n/translate';
import { copyTextFromElement } from '../util/CopyUtil';
import DOMPurify from 'dompurify';

export default class HelpModal extends Component {
  static propTypes = {
    showHelpModal: PropTypes.bool,
    toggleHelpModal: PropTypes.func,
    user: PropTypes.object
  }

  constructor(props){
    super(props);
    this.state = {};
  }

  copyToClipboard = () => {
    const success = copyTextFromElement('#help-modal-info', document.getElementById('help-modal'));
    this.setState({ copySuccess: success });
    setTimeout(() => this.setState({ copySuccess: null }), 2000);
  };

  getOS = () => {
    let OSName;
    if (typeof window !== 'undefined' && window.navigator && window.navigator.appVersion) {
      if (window.navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
      if (window.navigator.appVersion.indexOf("Mac") !== -1) OSName = "MacOS";
      if (window.navigator.appVersion.indexOf("X11") !== -1) OSName = "UNIX";
      if (window.navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux";
    }
    return OSName;
  }

  render() {
    const { showHelpModal, toggleHelpModal, user } = this.props;
    const { copySuccess } = this.state;

    const cookieEnabled = typeof window !== 'undefined' && window.navigator.cookieEnabled ? i18n.t('enabled') : i18n.t('disabled');
    const currentUrl = DOMPurify.sanitize(typeof window !== 'undefined' ? window.location.href : '');

    return (
      <Modal
        id="help-modal"
        className="help-modal modal-size-medium"
        dialogClassName="foundry"
        show={showHelpModal}
        aria-labelledby="help-modal-title"
      >
        <ModalHeader
          canClickOff={true}
          closeButton={true}
          onCancel={toggleHelpModal}
          title={i18n.t('Need Help?')}
          titleId="help-modal-title"
        />
        <Modal.Body>
          <h5>{i18n.t('System Requirements')}</h5>
          <p>{i18n.t('For best performance, use our')} <a href="https://everfi.com/minimum-system-requirements" target="_blank" className="f-700 branded-link">{i18n.t('minimum system requirements')}</a>.</p>
          <h5>{i18n.t('Technical Support')}</h5>
          <p>{ i18n.t('You can get help by accessing our') } <a href="https://support.everfi.com" target="_blank" className="f-700 branded-link">{ i18n.t('technical support site') }</a> { i18n.t('to read FAQs or chat with our support team.') }</p>
          <p>{i18n.t('Please copy and paste the information below into your support message:')}</p>
          <section id="help-modal-info">
            <div>{i18n.t('Platform')}: <span className="f-500" data-info-value="platform">{i18n.t('Foundry')}</span>  </div>
            {user && user.attributes &&
              <React.Fragment>
                <div>{i18n.t('Organization name')}: <span className="f-700" data-info-value="organization_name">{user.attributes.organization_name}</span>  </div>
                <div>{i18n.t('Organization ID')}: <span className="f-700" data-info-value="organization_id">{user.attributes.organization_id}</span>  </div>
                <div>{i18n.t('Operating system')}: <span className="f-700" data-info-value="operating_system">{this.getOS()}. {i18n.t('Cookies are {{cookieEnabled}}', { cookieEnabled })}. {i18n.t('Javascript is enabled')}. </span></div>
                <br />
                <div>{i18n.t('Name')}: <span className="f-700" data-info-value="user_name">{`${ user.attributes.first_name } ${ user.attributes.last_name }`}</span>  </div>
                <div>{i18n.t('User Type')}: <span className="f-700" data-info-value="user_type">{Object.keys(user.attributes.user_types).join(', ')}</span>  </div>
              </React.Fragment>
            }
            <div>{i18n.t('Current URL')}: <a href={currentUrl} className="f-700 branded-link" data-info-value="current_url">{currentUrl}</a></div>
          </section>
          {copySuccess === false && <span className="error">{i18n.t('Copy unsuccessful, please copy manually')}</span>}
          <Button className="btn-secondary btn-secondary-branded m-t-5" disabled={copySuccess} onClick={() => this.copyToClipboard()} data-action="copy">
            {copySuccess ?
              <React.Fragment>
                <Icon iconType="check" additionalClasses="m-l-0 m-r-5"/>
                {i18n.t('Copy Successful!')}
              </React.Fragment> :
              <React.Fragment>
                <Icon iconType="copy" additionalClasses="m-l-0 m-r-5"/>
                {i18n.t('Copy')}
              </React.Fragment>
            }
          </Button>
        </Modal.Body>
      </Modal>
    );
  }
}
